import { render, staticRenderFns } from "./CoverExplorer.vue?vue&type=template&id=04854018&"
import script from "./CoverExplorer.vue?vue&type=script&lang=ts&"
export * from "./CoverExplorer.vue?vue&type=script&lang=ts&"
import style0 from "./CoverExplorer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports